import { Link } from "@/i18n/routing";

/**
 * Doctors Vietnam brand logo.
 * Uses the official DoctorsVietnam.com asset in /public/brand/.
 * variant: "dark" (light backgrounds) | "light" (dark footer)
 */
export const Logo = ({ variant = "dark", className = "" }) => {
  const light = variant === "light";
  const ink = light ? "text-white" : "text-[#12365f]";
  const sub = light ? "text-white/60" : "text-[hsl(var(--vc-slate))]";
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2.5 ${className}`}
      aria-label="Doctors Vietnam home"
    >
      <img
        src="/brand/doctorsvietnam-logo.png"
        alt="Doctors Vietnam logo"
        width="44"
        height="44"
        loading="eager"
        decoding="async"
        className="h-11 w-11 shrink-0 object-contain"
      />
      <span className="flex flex-col leading-none">
        <span className={`text-lg font-extrabold tracking-tight sm:text-xl ${ink}`}>
          Doctors<span className="text-[#0f8a4c]">Vietnam</span>
          <span className={`ml-0.5 text-[0.72em] font-semibold ${sub}`}>.com</span>
        </span>
        <span
          className={`mt-1 hidden text-[0.6rem] font-semibold tracking-wide sm:block ${sub}`}
          data-testid="supported-by"
        >
          English-speaking medical support in Vietnam
        </span>
      </span>
    </Link>
  );
};

export default Logo;
